import { apiClient } from "./client";

interface UserResponse {
  id: string;
  email: string;
  name: string;
  accountType: "user" | "business";
  avatarUrl: string | null;
}

export async function getSession() {
  return apiClient<{ user: UserResponse }>("/auth/session");
}

export async function logout() {
  return apiClient<{ message: string }>("/auth/session", { method: "DELETE" });
}

export async function initiateGoogleOAuth() {
  return apiClient<{ url: string }>("/auth/google", { method: "POST" });
}

export async function requestMagicLink(email: string) {
  return apiClient<{ message: string }>("/auth/magic-link", {
    method: "POST",
    body: { email },
  });
}

export async function verifyMagicLink(token: string) {
  return apiClient<{ message: string; isNew: boolean }>(
    `/auth/magic-link/verify?token=${encodeURIComponent(token)}`
  );
}

export async function updateAccountType(accountType: "user" | "business") {
  return apiClient<{ user: UserResponse }>("/users/me", {
    method: "PATCH",
    body: { accountType },
  });
}
